import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { setUserDataToLocalStorage } from 'src/util/setUserDataToLocalStorage';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { getSelf, updateSelf, updatePassword } from '../services/napi';
import {
  ACCOUNT_FETCH_FAIL,
  SET_ACCOUNT,
  SET_ACCOUNT_PASSWORD,
  ACCOUNT_UPDATE_SUCCESS,
  ACCOUNT_PASSWORD_UPDATE_SUCCESS
} from '../constant/actionType';

function fetchAccountError() {
  return {
    error: 'ACCOUNT_FETCH_FAIL',
    type: ACCOUNT_FETCH_FAIL
  };
}

function updateAccountSuccess(data) {
  return { data, type: ACCOUNT_UPDATE_SUCCESS };
}

function updateAccountPasswordSuccess(data) {
  return { data, type: ACCOUNT_PASSWORD_UPDATE_SUCCESS };
}

export function fetchAccount() {
  return async (dispatch) => {
    try {
      const sessionId = getDataFromLocalStorage(LocalStorageKey.SESSION_ID);
      const response = await getSelf(sessionId);

      const userDraft = response.data.user;

      setUserDataToLocalStorage({
        role: userDraft.role
      });

      dispatch({ data: userDraft, type: SET_ACCOUNT });
    } catch (error) {
      console.error('FAILED TO FETCH ACCOUNT');
      dispatch(fetchAccountError());
    }
  };
}

export function setAccount(userDraft) {
  return async (dispatch) => {
    dispatch({ data: userDraft, type: SET_ACCOUNT });
  };
}

export function setPasswordAccount(passwordDraft) {
  return async (dispatch) => {
    dispatch({ data: passwordDraft, type: SET_ACCOUNT_PASSWORD });
  };
}

export function updateAccount(userObject) {
  return async (dispatch) => {
    try {
      const response = await updateSelf(userObject);

      dispatch(updateAccountSuccess(response));
    } catch (error) {
      console.error('FAILED TO UPDATE ACCOUNT');
    }
  };
}

export function updateAccountPassword(passwordObject) {
  return async (dispatch) => {
    try {
      const response = await updatePassword(passwordObject);

      dispatch(updateAccountPasswordSuccess(response));
    } catch (error) {
      console.error('FAILED TO UPDATE ACCOUNT PASSWORD');
    }
  };
}
